import { functions } from './functions.js';
import { logInfo } from './errors.js';

logInfo('VisualDX is Magic');

document.addEventListener("DOMContentLoaded", async () => {
    functions();
});


